<template>
  <div v-if="categorias.length > 0">
    <h1
      style="font-size: xx-large; line-height: 35px; font-weight: bold"
      :style="{ color: $ajustes.colorTexto2 }"
    >
      BIBLIOTECA
    </h1>
    <h1
      style="font-size: large; line-height: 35px; font-weight: normal"
      :style="{ color: $ajustes.colorTexto2 }"
    >
      Refuerza tus conocimientos
    </h1>
    <br />
    <h1
      class="center mb-7"
      style="font-size: xx-large; line-height: 35px; font-weight: bold"
      :style="{ color: $ajustes.colorTexto2 }"
    >
      CATEGORIAS DE LIBROS
    </h1>
    <v-row class="pt-2 center">
      <v-col
        class="ma-0 pa-2 pointer"
        lg="2"
        md="2"
        sm="4"
        cols="6"
        @click="goElibro()"
      >
        <v-img style="border-radius: 4px" :src="elibro">
          <div class="ma-2 pa-2 pr-5" style="color: white">
            <h1 style="color: #0d47a1; font-size: x-large">
              <strong>E-LIBRO</strong>
            </h1>
            <h4 style="color: #0d47a1; font-weight: 500">
              Accede a nuestra biblioteca digital
            </h4>
            <br />
            <h4 style="color: #44413f; font-weight: 500">
              Explora miles de títulos académicos y científicos en nuestra
              plataforma de libros electrónicos
            </h4>
          </div>
        </v-img>
      </v-col>
      <v-col
        class="ma-0 pa-2 pointer"
        v-for="categoria in categorias"
        :key="'categoria__s' + categoria"
        lg="2"
        md="2"
        sm="4"
        cols="6"
        @click="categoriaSelecionada = categoria"
      >
        <v-img style="border-radius: 4px" :src="$portadaLibros" class="center">
          <h2 class="ma-2" style="text-align: center; color: white">
            {{ categoria.titulo.toUpperCase() }}
          </h2>
        </v-img>
      </v-col>
    </v-row>
    <br />
    <hr />
    <div
      v-if="
        categoriaSelecionada && categoriaSelecionada.id && libros.length != 0
      "
    >
      <h1
        class="center mt-7 mb-3"
        style="font-size: xx-large; line-height: 35px; font-weight: bold"
        :style="{ color: $ajustes.colorTexto2 }"
      >
        LIBROS DE {{ categoriaSelecionada.titulo.toUpperCase() }}
      </h1>
      <v-row class="pt-2 center">
        <v-col
          class="ma-0 pa-1"
          v-for="libro in libros"
          :key="'libronnnc' + libro.id"
          lg="2"
          md="2"
          sm="4"
          cols="6"
        >
          <a
            :href="libro.enlace"
            target="_blank"
            rel="noopener noreferrer"
            style="text-decoration: none"
          >
            <v-img
              style="height: 50dvh; position: relative; border-radius: 4px"
              :src="
                libro.imagen_ruta
                  ? `${$env.pathImg}/${libro.imagen_ruta}`
                  : require('@/assets/default/book.png')
              "
              class="center"
              containt
            >
              <div
                class="absolute ml-0"
                style="
                  top: 0px;
                  border-left: 15px solid rgba(17, 71, 107, 0.9);
                  height: 100%;
                "
              ></div>
              <!-- Loader mientras carga -->
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </div>
              </template>

              <!-- Texto si no tiene imagen_ruta -->
              <h3 class="ma-6" style="color: white; text-align: left">
                {{ libro.imagen_ruta ? "" : libro.titulo }}
              </h3>
            </v-img>
          </a>
        </v-col>
      </v-row>
    </div>
    <br />
    <br />
    <h2 class="center">
      <a
        style="color: blue"
        href="https://welib.org/"
        target="_blank"
        rel="noopener noreferrer"
        >busca libros en WebLib</a
      >
    </h2>
    <br />
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  props: {
    propBibliotecas: { type: Array },
  },
  data() {
    return {
      categorias: [],
      libros: [],
      elibro: require("@/assets/default/elibro.png"),
      formularioDialogo: false,
      infoFormulario: { id: "", asunto: "", indicacion: "" },
      categoriaSelecionada: {},
    };
  },
  watch: {
    categoriaSelecionada() {
      if (this.categoriaSelecionada) {
        this.obtenerLibros(this.categoriaSelecionada.id);
      }
    },
  },
  mounted() {
    this.obtenerCategorias();
  },

  created() {},
  computed: {},
  methods: {
    async obtenerCategorias() {
      await axios
        .get("/obtener_categorias")
        .then((response) => {
          if (response.data) {
            this.categorias = response.data.data;
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerLibros(categoriaId) {
      this.libros = [];
      await axios
        .post("/obtener_libros", { categoriaId })
        .then((response) => {
          if (response.data) {
            if (response.data && response.data.data.length != 0) {
              this.libros = response.data.data;
            }
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    activarFormulario(id, titulo) {
      this.infoFormulario.id = id;
      this.infoFormulario.indicacion =
        "¿Estas interesado en parqticipar en el curso o taller de: " +
        titulo +
        "?";
      this.infoFormulario.asunto = "Interesado en " + titulo;
      this.formularioDialogo = true;
    },
    goElibro() {
      window.open("https://elibro.net/es/lc/insegt/", "_blank");
    },
    continuar() {},
    close() {},
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
